import Vue from 'vue'
import VueRouter from 'vue-router'

import isEqual from 'lodash.isequal'
import store from '@/store'
import { loadLanguageAsync } from '@/locales'

// import utils from '@/utils'

// 首页
const PageHome = resolve => require(['../views/home'], resolve)

// 2026 大赛升级 H5 长图文
const PageUpgradeH5 = resolve => require(['../views/h5/Upgrade2026'], resolve)

// 参赛规则
const PageRule = resolve => require(['../views/rule'], resolve)

// const PageWork = resolve => require(['../views/work'], resolve)

// 往届回顾 - 2025
const PagePast2025 = resolve => require(['../views/past/Past2025'], resolve)
// 往届回顾 - 2024
const PagePast2024 = resolve => require(['../views/past/Past2024'], resolve)
// 往届回顾 - 2023
const PagePast2023 = resolve => require(['../views/past/Past2023'], resolve)
// 往届回顾 - 2022
const PagePast2022 = resolve => require(['../views/past/Past2022'], resolve)
// 往届回顾 - 2021
const PagePast2021 = resolve => require(['../views/past/Past2021'], resolve)
// 往届回顾 - 2020
const PagePast2020 = resolve => require(['../views/past/Past2020'], resolve)
// 往届回顾 - 2019
const PagePast2019 = resolve => require(['../views/past/Past2019'], resolve)

// 入围名单
const PageAwards = resolve => require(['../views/awards/Awards'], resolve)
// 结果公布
const PageResult = resolve => require(['../views/result/Result'], resolve)

// 学习园地 - 区块链
const PageSupportBlockChain = resolve => require(['../views/SupportBlockChain/BlockChain'], resolve)
// 学习园地 - 人工智能
const PageSupportAI = resolve => require(['../views/SupportAI'], resolve)
// 学习园地 - 产品经理
const PageSupportPM = resolve => require(['../views/SupportPM'], resolve)

// const PageSupport = resolve => require(['@/views/support/Home.vue'], resolve)
// const PageLoading = resolve => require(['@/views/loading/Loading.vue'], resolve)

Vue.use(VueRouter)

const primaryRoutes = [
  // 首页
  {
    path: '/',
    name: 'Home',
    component: PageHome,
    meta: { id: 1 }
  },
  {
    path: '/upgrade-2026',
    name: 'Upgrade2026',
    component: PageUpgradeH5,
    meta: { id: 7, scrollToTop: true }
  },

  // 参赛规则
  {
    path: '/rule',
    name: 'Rule',
    component: PageRule,
    meta: { id: 2 }
  },
  // 往届回顾
  {
    path: '/past/2025',
    name: 'Past2025',
    component: PagePast2025,
    meta: { id: 3 }
  },
  {
    path: '/past/2024',
    name: 'Past2024',
    component: PagePast2024,
    meta: { id: 3 }
  },

  // 往届回顾
  {
    path: '/past/2023',
    name: 'Past2023',
    component: PagePast2023,
    meta: { id: 3 }
  },
  // 往届回顾
  {
    path: '/past/2022',
    name: 'Past2022',
    component: PagePast2022,
    meta: { id: 3 }
  },
  {
    path: '/past/2021',
    name: 'Past2021',
    component: PagePast2021,
    meta: { id: 3 }
  },
  {
    path: '/past/2020',
    name: 'Past2020',
    component: PagePast2020,
    meta: { id: 3 }
  },
  {
    path: '/past/2019',
    name: 'Past2019',
    component: PagePast2019,
    meta: { id: 2019 }
  },

  {
    path: '/awards',
    name: 'Awards',
    component: PageAwards,
    meta: { id: 5 }
  },

  {
    path: '/result',
    name: 'Result',
    component: PageResult,
    meta: { id: 6 }
  },

  // 学习园地 - 区块链
  {
    path: '/support/blockchain',
    name: 'SupportBlockchain',
    component: PageSupportBlockChain,
    meta: { id: 4 }
  },

  // 学习园地 - 人工智能
  {
    path: '/support/ai',
    name: 'SupportAI',
    component: PageSupportAI,
    meta: { id: 4 }
  },

  // 学习园地 - 产品经理
  {
    path: '/support/pm',
    name: 'SupportPM',
    component: PageSupportPM,
    meta: { id: 4 }
  }

  // {
  //   path: '/works',
  //   name: 'Works',
  //   component: PageWork
  // },
]

const englishRoutes = primaryRoutes.map(route => ({
  ...route,
  path: route.path === '/' ? '/en/' : `/en${route.path}`,
  name: `${route.name}En`,
  meta: {
    ...route.meta,
    locale: 'en-US',
    primaryName: route.name
  }
}))

const routes = primaryRoutes.concat(englishRoutes)
const isStandaloneBuild = process.env.VUE_APP_STANDALONE_BUILD === 'true'

const router = new VueRouter({
  mode: isStandaloneBuild ? 'hash' : 'history',
  base: isStandaloneBuild ? '/' : (process.env.VUE_APP_BUILD_ENV !== 'test' ? '/zones/fintechathon/campus2025' : '/zones/test/fintechathon/campus2025'),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition
    } else {
      const position = {}
      // new navigation.
      // scroll to anchor by returning the selector
      if (to.hash) {
        position.selector = to.hash
      }
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some(m => m.meta.scrollToTop)) {
        // cords will be used if no selector is provided,
        // or if the selector didn't match any element.
        position.x = 0
        position.y = 0
      }

      if (!Object.keys(position).length) {
        position.x = 0
        position.y = 0
      }

      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return position
    }
  }
})

router.beforeEach(async (to, from, next) => {
  const preferredLanguage = window.localStorage.getItem('fintechathon-language')
  const injectedCountry = window.__FINTECHATHON_COUNTRY_CODE__ || document.querySelector('meta[name="geo-country"]')?.content || to.query.country
  const countryCode = `${injectedCountry || ''}`.toUpperCase()
  const firstVisit = !preferredLanguage && from.matched.length === 0
  const neutralHome = to.path === '/'
  const outsideChina = countryCode && !['CN', 'HK', 'MO', 'TW'].includes(countryCode)

  // 本地可用 ?country=US 模拟海外 IP；生产环境由 CDN 注入国家代码。
  if (firstVisit && neutralHome && outsideChina) {
    next({ path: '/en/', query: to.query, hash: to.hash })
    return
  }

  const locale = to.meta.locale === 'en-US' ? 'en-US' : 'zh-CN'
  await loadLanguageAsync(locale)
  store.commit('SET_LANG', locale)

  const query = Object.assign({}, from.query, to.query)
  if (to.path !== from.path) {
    const keys = Object.keys(query)
    if (keys.length) {
      keys.forEach(key => {
        if (key.indexOf('utm_') < 0 && key.indexOf('sign') < 0) {
          delete query[key]
        }
      })
    }
  }
  if (isEqual(query, to.query)) {
    next()
  } else {
    next({ path: to.path, query, hash: to.hash })
  }
})

export default router
